import { createApi } from '@reduxjs/toolkit/query/react';
import { Endpoints } from 'src/config';
import { apiHelper } from 'src/utils/apiHelper';
import { baseQuery, tagType } from 'src/utils/baseQuery';

const tags = {
  list: 'tag-list',
};

const TagApi = createApi({
  reducerPath: 'tag-api',
  baseQuery: baseQuery(),
  tagTypes: [tags.list],
  endpoints: (builder) => ({
    getTags: builder.query({
      providesTags: [tagType(tags.list)],
      query: (body) => apiHelper(Endpoints.tag.list, body),
    }),
    createTag: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.tag.create,
        method: 'post',
        body: body,
      }),
    }),
    editTag: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.tag.edit,
        method: 'post',
        body: body,
      }),
    }),
    deleteTag: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.tag.delete,
        method: 'post',
        body,
      }),
    }),
  }),
});

export const { useGetTagsQuery, useCreateTagMutation, useEditTagMutation, useDeleteTagMutation } =
  TagApi;
export { TagApi };
